module.exports = __webpack_public_path__ + "static/media/CD.fbcda149.png";